<template>
  <form
    class="brazil-form"
    @submit.prevent="submit"
  >
    <slot />
  </form>
</template>
<script>
// Brazil Form (v1) is less flexible because of its use of the router
// We will move to Brazil Form V2 over time.
export default {
  props: {
    validator: {
      type:     [Object],
      required: false,
      default:  undefined,
    },
  },
  methods: {
    async submit() {
      if (this.valid()) {
        this.$emit('submit');
      } else {
        this.$emit('error');
      }
    },
    valid() {
      if (this.validator === undefined || this.validator === null) {
        return true;
      }
      this.validator.$touch();
      return !this.validator.$invalid;
    },
  },
};
</script>
<style lang="scss" module>
  .registration-field {
    width: calc(100% - 8px);

    .form-group {
      margin-bottom: 1.6rem;

      &:last-child {
        margin-bottom: 0;
      }

      input {
        display: block;
        width: 100%;
        margin-bottom: 0.5rem;
        border: 1px solid #d1d1d1;
        border-radius: 4px;
        background-color: #fafafa;
        color: #4a4a4a;
        font-weight: 400;
        font-size: 14px;
        vertical-align: middle;
        padding: .6rem 1rem;
        height: 2.5rem;
        line-height: inherit;
        box-sizing: border-box;
        &.valid {
          border: 1px solid #05a006;
        }
        &.error {
          border: 1px solid #d0021b;
        }
      }
      .btn-group {
        label {
          display: block;
          position: relative;
          margin-bottom: 1.6rem;
          display: block;
          padding-left: 3.5em;
          line-height: inherit;
        input[type="radio"] {
              display: inline-block;
              width: auto;
              height: 18px;
              width: 18px;
              position: absolute;
              top: 0;
              left: 0;
        }
      }
      }
    }
  }

  @media (min-width: 769px) {
    .registration-field {
      width: calc(100% / 2 - 8px);
    }
  }
</style>
